import { type SVGProps } from 'react';

import { withDynamicStroke } from '../../withDynamicStroke';
const Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M6 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 0c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2-1.343-2-3-2Zm12 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 0c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2-1.343-2-3-2Zm-6 4C6.477 22 2 17.523 2 12M12 2c5.523 0 10 4.477 10 10"
    />
  </svg>
);
export const IconCommunity = withDynamicStroke(Icon);
